import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HasuShoriKbn = props => {
  return (
    <Dropdown.Static kubunKey='seikyu_tani_zei_hasu_shori_kbn' {...props} />
  )
}
